import React, { useState } from 'react';
import MovementDetailPanel from '../movements/MovementDetailPanel';
import usePhoneHomeCurrency from '../../hooks/usePhoneHomeCurrency';

/**
 * One movement, over any phone page: the movement detail panel in its phone
 * layout, a full-height sheet.
 *
 * Each opening mounts the panel afresh, so it reads the movement as it is now
 * and never shows edits discarded the last time. It stays mounted while it
 * closes, so the sheet can slide away.
 */
export default function PhoneMovementSheet({ movementId, isOpen, onClose, onChanged }) {
  // The currency the rows print without a code, so the sheet's amounts read
  // as the row's do.
  const homeCurrency = usePhoneHomeCurrency();
  const [wasOpen, setWasOpen] = useState(isOpen);
  const [opening, setOpening] = useState(0);
  if (isOpen !== wasOpen) {
    setWasOpen(isOpen);
    if (isOpen) setOpening(opening + 1);
  }

  if (movementId == null) return null;
  return (
    <MovementDetailPanel
      key={`${movementId}-${opening}`}
      layout="phone"
      phoneHomeCurrency={homeCurrency}
      isOpen={isOpen}
      movementId={movementId}
      onClose={onClose}
      onMovementUpdated={() => onChanged?.()}
      onMovementDeleted={() => onChanged?.()}
    />
  );
}
